import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { StaffWorkLogsContext } from "../StaffWorkLogsDetail";
import { formatDisplayHours } from "../utils/general";

export const ClientHoursSummary = () => {
    const {
        totals: { totalClientHours, nonClientHours },
    } = useContext(StaffWorkLogsContext);

    return (
        <Box textAlign="left">
            <Typography variant="h6" color="primary">
                Detalhe horas
            </Typography>
            <Typography>Horas clientes: {formatDisplayHours(totalClientHours)}</Typography>
            <Typography>Horas não clientes: {formatDisplayHours(nonClientHours)}</Typography>
        </Box>
    );
};
